import { useMutation } from '@apollo/client';
import { CREATE_OTHER_ITEM, GET_OTHER_ITEMS } from '../graphql';
import {
  CreateOtherItem,
  CreateOtherItemVariables,
} from '../graphql-types/CreateOtherItem';

export const useCreateOtherItem = () => {
  const [mutate, state] = useMutation<
    CreateOtherItem,
    CreateOtherItemVariables
  >(CREATE_OTHER_ITEM, {
    refetchQueries: [GET_OTHER_ITEMS],
  });

  const createOtherItem = async (
    input: CreateOtherItemVariables['input'],
  ) => {
    const { data } = await mutate({
      variables: { input },
    });

    return data?.createOtherItem;
  };

  return {
    createOtherItem,
    ...state,
  };
};
